const notifications = {
    namespaced: true,
    state: {
        list: []
    },
    mutations: {
        add(state, { notification }){
            state.list = [...state.list, notification]
        },
        remove(state, {notification}){
            const idx = state.list.indexOf(notification)
            const list = [...state.list]
            list.splice(idx, 1)
            state.list = list
        },
    },
    actions: {
        create({ commit }, { notification, timing = 5000}) {
            commit('add', {notification});

            setTimeout(() => {
                commit('remove', {notification});
            }, timing);
        },
        add({ commit }, {notification}){
            commit('add', {notification});
        },
        remove({ commit }, {notification}){
            commit('remove', {notification});
        },
        
    }
}
export default notifications
